import { useCallback } from "react";
import { LicenseManagerApi, useAPIAction } from "melco-shared-logic";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getUTCObjectFromLocalDate } from "../../helper/dateHelper";

dayjs.extend(utc);
export interface LicenseManagerInterface {
  assign_license?: boolean;
  email_address?: string;
  product_code: string;
  referral_code: string;
  subscription_code: string;
  version_id: string;
  is_validate_only: boolean;
  language?: string | null;
  melco_customer_id?: string | null;
  subscription_start_date?: Date | null;
  affiliate_code?: string | null
}

export const useLicenseManager = () => {
  const [LicenseManager] = useAPIAction(
    LicenseManagerApi,
    async (api, LicenseManagerDetails: LicenseManagerInterface) => {
      const localDate = LicenseManagerDetails.subscription_start_date;

      let data = await api.licenseManagerLicensesManagerCreate({
        controlcenterMelcoControlCenterModelsUserLicense: {
          assign_license: LicenseManagerDetails.assign_license,
          product_code: LicenseManagerDetails.product_code,
          email_address: LicenseManagerDetails.email_address,
          referral_code: LicenseManagerDetails.referral_code,
          subscription_code: LicenseManagerDetails.subscription_code,
          version_id: LicenseManagerDetails.version_id,
          is_validate_only: LicenseManagerDetails.is_validate_only,
          language: LicenseManagerDetails.language,
          melco_customer_id: LicenseManagerDetails.melco_customer_id,
          subscription_start_date: localDate
            ? getUTCObjectFromLocalDate(localDate).utcStartOfDay
            : undefined,
          affiliate_code: LicenseManagerDetails.affiliate_code
        },
      });

      return {
        successMessages: !LicenseManagerDetails.is_validate_only
          ? [{ message: "default" }]
          : [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "licensemanager.create",
    }
  );

  return useCallback(
    async (LicenseManagerDetails: LicenseManagerInterface) => {
      return await LicenseManager(LicenseManagerDetails);
    },
    [LicenseManager]
  );
};
